// \assets\Wishlist.js.liquid


;(function (Wishlist, $) {
  var PRODUCT_NEW_TIME_DAYS = "30";

  var wishlist = localStorage.getItem('user_wishlist') || [];
  if (wishlist.length > 0) {
    wishlist = JSON.parse(localStorage.getItem('user_wishlist'));
  }
  // clean up any stray empty-string entries from older versions of this script
  wishlist = wishlist.filter(function (handle) { return !!handle; });

  /*
   * Format a price in cents using the theme's money_format setting.
   * Falls back to a plain "$0.00"-style format if Shopify.formatMoney isn't available.
   */
  var formatMoney = function (cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.moneyFormat);
    }
    var value = (cents / 100).toFixed(2);
    var format = window.moneyFormat || '${{amount}}';
    return format.replace(/\{\{\s*amount\s*\}\}/, value);
  };

  /*
   * Sync a single wishlist button's visual state (the 'is-active' class used
   * for the heart-icon styling on grid tiles, and the button's own label text
   * used in places like the quickview modal, which doesn't hide its <span>).
   * Reads the label strings from data-label-add / data-label-remove so this
   * works regardless of shop language.
   */
  var setButtonState = function ($btn, isActive) {
    $btn.toggleClass('is-active', isActive);
    var label = isActive ? $btn.attr('data-label-remove') : $btn.attr('data-label-add');
    if (label) {
      $btn.find('span').first().text(label);
      // Bootstrap reads data-original-title. Do not set title — that brings
      // back the native browser tooltip on product-page / quickview text buttons.
      $btn.attr('data-original-title', label).removeAttr('title');
      // Bootstrap won't refresh an already-open tooltip's visible text on the
      // fly - it only re-reads data-original-title on the next mouseenter/show.
      // Hide it now so the next hover picks up the text we just set above.
      if ($btn.data('bs.tooltip')) $btn.tooltip('hide');
    }
  };

  /*
   * Add/Remove a product handle to/from the wishlist array in localStorage.
   * Used by wishlist-heart buttons on product tiles/quickview across the site.
   *
   * The wishlist array (not the clicked button's own 'is-active' class) is the
   * source of truth for whether a product is already wishlisted - a product can
   * have multiple heart buttons on the same page (e.g. grid tile + quickview
   * modal), and only one of them may have been synced with 'is-active' on page
   * load. Deciding from the button's own class caused duplicate handles when a
   * not-yet-synced button (like quickview's) was clicked after the tile's.
   */
  var updateWishlist = function (self) {
    var productHandle = $(self).attr('data-product-handle');
    var removeIndex = wishlist.indexOf(productHandle);
    var isRemoving = removeIndex > -1;

    if (isRemoving) {
      wishlist.splice(removeIndex, 1);
      if (typeof toastr !== 'undefined') toastr.info('Product removed from wishlist.');
    } else {
      wishlist.push(productHandle);
      if (typeof toastr !== 'undefined') toastr.success('Product added to wishlist.');
    }
    localStorage.setItem('user_wishlist', JSON.stringify(wishlist));

    // Sync every button for this product on the current page (grid tile, quickview, etc.)
    $('.wishlist-btn[data-product-handle="' + productHandle + '"]').each(function () {
      setButtonState($(this), !isRemoving);
    });

    $('#wishlist-total span.count').html(wishlist.length);
  };

  /*
   * Remove a product handle from the wishlist and remove its row from the
   * wishlist page table, if present.
   */
 var removeFromWishlistPage = function (self) {
  var productHandle = $(self).attr('data-product-handle');
  var removeIndex = wishlist.indexOf(productHandle);
  if (removeIndex > -1) wishlist.splice(removeIndex, 1);
  localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
  if (typeof toastr !== 'undefined') toastr.info('Product removed from wishlist.');

  // Прячем тултип ДО удаления строки - иначе подсказка (она в <body>, не внутри кнопки) зависает
  if ($(self).data('bs.tooltip')) $(self).tooltip('hide');

  $(self).closest('tr').fadeOut(200, function () {
    $(this).remove();
    if ($('#wishlist-items tr').length === 0) {
      $('.wishlist-table-wrap').hide();
      $('.wishlist-empty').show();
    }
  });
};

  /*
   * Loop through wishlist heart buttons on the current page (tiles, quickview, etc.)
   * and sync their is-active class + label text to match the current wishlist.
   * Exposed as Wishlist.refresh() so quickview.js can re-run this after it swaps
   * in a new product's data-product-handle when the modal opens for a different item.
   */
  var activateItemsInWishlist = function () {
    $('.wishlist-btn').each(function () {
      var $btn = $(this);
      var productHandle = $btn.attr('data-product-handle');
      setButtonState($btn, wishlist.indexOf(productHandle) > -1);
    });
    $('#wishlist-total span.count').html(wishlist.length);
  };

  /*
   * Build a single wishlist table row for a product fetched from /products/{handle}.js
   * Image markup mirrors cart-page.liquid's images-container/product-image structure
   * so the same CSS (square frame, object-fit, etc.) applies here without duplication.
   */
var buildWishlistRow = function (product) {
  var image = product.featured_image
    ? product.featured_image.replace('.jpg', '_medium.jpg').replace('.png', '_medium.png')
    : '';
  var price = formatMoney(product.price);

  var isSoldOut = !product.available;
  var isOnSale = product.compare_at_price > product.price;
  var discountPercent = isOnSale
    ? Math.round((product.compare_at_price - product.price) * 100.0 / product.compare_at_price)
    : 0;
  var createdAtSec = new Date(product.created_at).getTime() / 1000;
  var nowSec = Date.now() / 1000;
  var daysSinceCreated = (nowSec - createdAtSec) / 86400;
  var isNew = daysSinceCreated < PRODUCT_NEW_TIME_DAYS;

  var tpl = document.getElementById('wishlist-row-template');
  var rowNode = document.importNode(tpl.content.querySelector('tr'), true);
  var $row = $(rowNode);

  $row.attr('data-product-handle', product.handle);

  $row.find('.wishlist-row-image').attr({ src: image, alt: product.title, title: product.title });
  $row.find('a.wishlist-row-link').attr('href', product.url);
  $row.find('a.table-product-title').text(product.title);
  $row.find('.wishlist-money').text(price);
  $row.find('.wishlist-remove-btn').attr('data-product-handle', product.handle);

  $row.toggleClass('is-sold-out', isSoldOut);
  $row.find('.btn-primary').toggleClass('disabled-link', isSoldOut);

  $row.find('.label-sold-out').toggle(isSoldOut);
  $row.find('.label-new').toggle(!isSoldOut && isNew);
  $row.find('.label-sale').toggle(!isSoldOut && isOnSale);
  $row.find('.label-sale-percent').text('-' + discountPercent + '%');

  return $row;
};

  /*
   * Fetch each wishlisted product by handle and render it into the table.
   * Missing/unavailable handles (deleted products) are silently skipped.
   */
  var renderWishlistPage = function () {
  var $tbody = $('#wishlist-items');
  if ($tbody.length === 0) return; // not on the wishlist page

  if (wishlist.length === 0) {
    $('.wishlist-loader').fadeOut(200);
    $('.wishlist-empty').show();
    return;
  }

  var requests = wishlist.map(function (handle) {
    return $.getJSON('/products/' + handle + '.js').then(function (product) {
      return product;
    }, function () {
      return $.Deferred().resolve(null).promise();
    });
  });

  $.when.apply($, requests).always(function () {
    var results = requests.length === 1 ? [arguments[0]] : Array.prototype.slice.call(arguments);
    var rendered = 0;

    results.forEach(function (product) {
      if (product) {
        $tbody.append(buildWishlistRow(product));
        rendered++;
      }
    });

    $('.wishlist-loader').fadeOut(200, function () {
      if (rendered === 0) {
        $('.wishlist-empty').show();
      } else {
        $('.wishlist-table-wrap').show();
      }
    });
  });
};

  var bindUIActions = function () {
    // Wishlist heart buttons on product tiles/quickview across the site
    $(document).on('click', '.wishlist-btn:not(.wishlist-remove-btn)', function (e) {
      e.preventDefault();
      updateWishlist(this);
    });

    // Remove buttons inside the wishlist page table (added dynamically, so delegated)
    $(document).on('click', '.wishlist-remove-btn', function (e) {
      e.preventDefault();
      removeFromWishlistPage(this);
    });

    $(document).on('click', '.wishlist-table-wrap .btn-primary', function (e) {
      if ($(this).hasClass('disabled-link')) e.preventDefault();
    });
  };

  Wishlist.init = function () {
    bindUIActions();
    activateItemsInWishlist();
    renderWishlistPage();
  };

  // Public: re-sync all wishlist buttons' is-active class + label text.
  // Called by quickview.js after it updates the modal's data-product-handle,
  // so the heart/text reflects the newly-displayed product, not the previous one.
  Wishlist.refresh = activateItemsInWishlist;

}(window.Wishlist = window.Wishlist || {}, jQuery, undefined));
